// dummy data to test stat update func
// const matchWeeks = [
//   {
//     week: 1,
//     startDate: new Date("2025-05-12T00:00:00+05:30"),
//     endDate: new Date("2025-05-16T00:00:00+05:30"),
//     lockingDate: new Date("2025-05-15T00:00:00+05:30"),
//     adminDate: new Date("2025-05-17T00:00:00+05:30"),
//   },
//   {
//     week: 2,
//     startDate: new Date("2025-05-17T00:00:00+05:30"),
//     endDate: new Date("2025-05-23T00:00:00+05:30"),
//     lockingDate: new Date("2025-05-22T00:00:00+05:30"),
//     adminDate: new Date("2025-05-24T00:00:00+05:30"),
//   },
//   {
//     week: 3,
//     startDate: new Date("2025-05-24T00:00:00+05:30"),
//     endDate: new Date("2025-05-27T00:00:00+05:30"),
//     lockingDate: new Date("2025-05-26T00:00:00+05:30"),
//     adminDate: new Date("2025-05-28T00:00:00+05:30"),
//   },
//   {
//     week: 4,
//     startDate: new Date("2025-05-28T00:00:00+05:30"),
//     endDate: new Date("2025-05-30T00:00:00+05:30"),
//     lockingDate: new Date("2025-05-29T00:00:00+05:30"),
//     adminDate: new Date("2025-06-01T00:00:00+05:30"),
//   },
//   {
//     week: 5,
//     startDate: new Date("2025-06-01T00:00:00+05:30"),
//     endDate: new Date("2025-06-07T00:00:00+05:30"),
//     lockingDate: new Date("2025-06-06T00:00:00+05:30"),
//     adminDate: new Date("2025-06-08T00:00:00+05:30"),
//   },
//   {
//     week: 6,
//     startDate: new Date("2025-06-08T00:00:00+05:30"),
//     endDate: new Date("2025-06-11T00:00:00+05:30"),
//     lockingDate: new Date("2025-06-10T00:00:00+05:30"),
//     adminDate: new Date("2025-06-12T00:00:00+05:30"),
//   },
//   {
//     week: 7,
//     startDate: new Date("2025-06-12T00:00:00+05:30"),
//     endDate: new Date("2025-06-14T00:00:00+05:30"),
//     lockingDate: new Date("2025-06-13T00:00:00+05:30"),
//     adminDate: new Date("2025-06-15T00:00:00+05:30"),
//   },
//   {
//     week: 8,
//     startDate: new Date("2025-06-15T00:00:00+05:30"),
//     endDate: new Date("2025-06-21T00:00:00+05:30"),
//     lockingDate: new Date("2025-06-20T00:00:00+05:30"),
//     adminDate: new Date("2025-06-22T00:00:00+05:30"),
//   },
//   {
//     week: 9,
//     startDate: new Date("2025-06-22T00:00:00+05:30"),
//     endDate: new Date("2025-07-04T00:00:00+05:30"),
//     lockingDate: new Date("2025-07-03T00:00:00+05:30"),
//     adminDate: new Date("2025-07-05T00:00:00+05:30"),
//   },
// ];
// export default matchWeeks;

// 2025 data
// -----> if locking time for all fantasy weeks is changed from (n-1)day T00:00:00+05:30 to n day T14:00:00+05:30 :
// -----> it doesn't close it on 2pm of nth dy it will no close on that time so check all the logics in that for 2026
// 


//2026 Match weeks data
const matchWeeks = [
  {
    week: 1,
    startDate: new Date("2026-06-14T00:00:00+05:30"),
    endDate: new Date("2026-06-21T00:00:00+05:30"),
    lockingDate: new Date("2026-06-20T00:00:00+05:30"),
    adminDate: new Date("2026-06-22T00:00:00+05:30"),
  },
  {
    week: 2,
    startDate: new Date("2026-06-22T00:00:00+05:30"),
    endDate: new Date("2026-06-24T00:00:00+05:30"),
    lockingDate: new Date("2026-06-23T00:00:00+05:30"),
    adminDate: new Date("2026-06-25T00:00:00+05:30"),
  },
  {
    week: 3,
    startDate: new Date("2026-06-25T00:00:00+05:30"),
    endDate: new Date("2026-06-28T00:00:00+05:30"),
    lockingDate: new Date("2026-06-27T00:00:00+05:30"),
    adminDate: new Date("2026-07-02T00:00:00+05:30"),
  },
  {
    week: 4,
    startDate: new Date("2026-06-29T00:00:00+05:30"),
    endDate: new Date("2026-07-05T00:00:00+05:30"),
    lockingDate: new Date("2026-07-04T00:00:00+05:30"),
    adminDate: new Date("2026-07-10T00:00:00+05:30"),
  },
  {
    week: 5,
    startDate: new Date("2026-07-06T00:00:00+05:30"),
    endDate: new Date("2026-07-12T00:00:00+05:30"),
    lockingDate: new Date("2026-07-11T00:00:00+05:30"),
    adminDate: new Date("2026-07-15T00:00:00+05:30"),
  },
  {
    week: 6,
    startDate: new Date("2026-07-13T00:00:00+05:30"),
    endDate: new Date("2026-07-15T00:00:00+05:30"),
    lockingDate: new Date("2026-07-14T00:00:00+05:30"),
    adminDate: new Date("2026-07-18T00:00:00+05:30"),
  },
  {
    week: 7,
    startDate: new Date("2026-07-16T00:00:00+05:30"),
    endDate: new Date("2026-07-19T00:00:00+05:30"),
    lockingDate: new Date("2026-07-18T00:00:00+05:30"),
    adminDate: new Date("2026-07-24T00:00:00+05:30"),
  },
  {
    week: 8,
    startDate: new Date("2026-07-20T00:00:00+05:30"),
    endDate: new Date("2026-07-26T00:00:00+05:30"),
    lockingDate: new Date("2026-07-25T00:00:00+05:30"),
    adminDate: new Date("2026-07-29T00:00:00+05:30"),
  },
  {
    week: 9,
    startDate: new Date("2026-07-27T00:00:00+05:30"),
    endDate: new Date("2026-08-02T00:00:00+05:30"),
    lockingDate: new Date("2026-08-01T00:00:00+05:30"),
    adminDate: new Date("2026-08-05T00:00:00+05:30"),
  },
];


export default matchWeeks;

// 2024 data
// const matchWeeks = [
//   {
//     week: 1,
//     startDate: new Date("2024-06-12T00:00:00+05:30"),
//     endDate: new Date("2024-06-16T00:00:00+05:30"),
//     lockingDate: new Date("2024-06-15T00:00:00+05:30"),
//     adminDate: new Date("2024-06-17T00:00:00+05:30"),
//   },
//   {
//     week: 2,
//     startDate: new Date("2024-06-17T00:00:00+05:30"),
//     endDate: new Date("2024-06-23T00:00:00+05:30"),
//     lockingDate: new Date("2024-06-22T00:00:00+05:30"),
//     adminDate: new Date("2024-06-24T00:00:00+05:30"),
//   },
//   {
//     week: 3,
//     startDate: new Date("2024-06-24T00:00:00+05:30"),
//     endDate: new Date("2024-06-27T00:00:00+05:30"),
//     lockingDate: new Date("2024-06-26T00:00:00+05:30"),
//     adminDate: new Date("2024-06-28T00:00:00+05:30"),
//   },
//   {
//     week: 4,
//     startDate: new Date("2024-06-28T00:00:00+05:30"),
//     endDate: new Date("2024-06-30T00:00:00+05:30"),
//     lockingDate: new Date("2024-06-29T00:00:00+05:30"),
//     adminDate: new Date("2024-07-01T00:00:00+05:30"),
//   },
//   {
//     week: 5,
//     startDate: new Date("2024-07-01T00:00:00+05:30"),
//     endDate: new Date("2024-07-07T00:00:00+05:30"),
//     lockingDate: new Date("2024-07-06T00:00:00+05:30"),
//     adminDate: new Date("2024-07-08T00:00:00+05:30"),
//   },
//   {
//     week: 6,
//     startDate: new Date("2024-07-08T00:00:00+05:30"),
//     endDate: new Date("2024-07-11T00:00:00+05:30"),
//     lockingDate: new Date("2024-07-10T00:00:00+05:30"),
//     adminDate: new Date("2024-07-12T00:00:00+05:30"),
//   },
//   {
//     week: 7,
//     startDate: new Date("2024-07-12T00:00:00+05:30"),
//     endDate: new Date("2024-07-14T00:00:00+05:30"),
//     lockingDate: new Date("2024-07-13T00:00:00+05:30"),
//     adminDate: new Date("2024-07-15T00:00:00+05:30"),
//   },
//   {
//     week: 8,
//     startDate: new Date("2024-07-15T00:00:00+05:30"),
//     endDate: new Date("2024-07-21T00:00:00+05:30"),
//     lockingDate: new Date("2024-07-20T00:00:00+05:30"),
//     adminDate: new Date("2024-07-22T00:00:00+05:30"),
//   },
//   {
//     week: 9,
//     startDate: new Date("2024-07-22T00:00:00+05:30"),
//     endDate: new Date("2024-08-04T00:00:00+05:30"),
//     lockingDate: new Date("2024-08-03T00:00:00+05:30"),
//     adminDate: new Date("2024-08-05T00:00:00+05:30"),
//   },
// ];
// export default matchWeeks;
